<div class="checkbox-options-wrapper">
  @if (searchEnabled) {
  <div class="mb-16-px">
    <app-search-input [control]="searchControl" [name]="name" [placeholder]="'Search'" [secondary]="true">
    </app-search-input>
  </div>
  }
  <div class="inner-scroll-container">
    @if(initialLoading){
    <p-skeleton width="100%" height="16px" class="mb-8-px"></p-skeleton>
    <p-skeleton width="100%" height="16px" class="mb-8-px"></p-skeleton>
    <p-skeleton width="100%" height="16px" class="mb-8-px"></p-skeleton>
    <p-skeleton width="100%" height="16px" class="mb-8-px"></p-skeleton>
    <p-skeleton width="100%" height="16px" class="mb-8-px"></p-skeleton>
    } @else {
    @for (checkbox of checkboxOptions | filterCheckboxOptions: searchControl?.value : 'label'; track checkbox.value; let
    last = $last) {
    <app-checkbox-control [disabled]="(loading$ | async) || checkbox.count === 0"
      (onChangeEvent)="onOptionsChange($event)"
      [classess]="last ? 'filter-option-checkbox mb-unset' : 'filter-option-checkbox mb-8-px'"
      [control]="filterOptionsFormGroup?.get(checkbox.value)" [value]="checkbox.value" [count]="checkbox.count"
      [name]="checkbox.value" [binary]="false" [label]="checkbox.label" [labelPosition]="'After'">
    </app-checkbox-control>
    }
    @empty {
    <span class="empty-text">No options available</span>

    }
    }

  </div>
</div>
